import React from "react";

import { Button, Dialog, DialogTrigger, makeStyles, Toolbar, ToolbarGroup } from "@fluentui/react-components";
import { ArrowClockwise16Filled, ArrowClockwise16Regular, PeopleEdit16Filled, PeopleEdit16Regular, bundleIcon, ArrowExport16Filled, ArrowExport16Regular } from "@fluentui/react-icons";
import { useUserUnassignmentDialogStore } from "../store/UserUnassignmentDialogStore";
import { useUserAssignmentsContext } from "../context/UserAssignmentContext";
import { useUserAssignmentExportDialogStore } from "../store/UserAssignmentExportDialogStore";
import AssignmentDialog from "./AssignmentDialog";
import UnassignmentInfo from "./UnassignmentInfo";
import ExportInfo from "./ExportInfo";

const UnassignBundle = bundleIcon(PeopleEdit16Filled, PeopleEdit16Regular);
const RefreshBundle = bundleIcon(ArrowClockwise16Filled, ArrowClockwise16Regular);
const ExportBundle = bundleIcon(ArrowExport16Filled, ArrowExport16Regular);

const useStyles = makeStyles({
    toolbar: {
        justifyContent: "end",
        padding: "5px 0px",
    }
});

export default function UserAssignmentToolbar() {
    const styles = useStyles();
    const { isOpen: isUnassign, openUnassignment } = useUserUnassignmentDialogStore();
    const { isOpen: isExport, openExportDialog } = useUserAssignmentExportDialogStore();

    const { refetchListOption, refetchUserAssignment, isListOptionFetching, isUserAssignmentFetching } = useUserAssignmentsContext();

    const handleRefresh = React.useCallback(() => {
        refetchListOption();
        refetchUserAssignment();
    }, [refetchListOption, refetchUserAssignment]);

    return (
        <Toolbar
            aria-label="Device toolbar"
            className={styles.toolbar}
            size="medium"
        >
            <ToolbarGroup>
                <Dialog open={isUnassign} onOpenChange={openUnassignment} modalType="modal">
                    <DialogTrigger disableButtonEnhancement>
                    <Button
                        aria-label="Unassign"
                        shape="circular"
                        appearance="subtle"
                        icon={<UnassignBundle />}
                        onClick={openUnassignment}
                    >Unassign</Button>
                    </DialogTrigger>
                    <AssignmentDialog children={<UnassignmentInfo/>}/>
                </Dialog>
                <Dialog open={isExport} onOpenChange={openExportDialog} modalType="modal">
                    <DialogTrigger disableButtonEnhancement>
                    <Button
                        aria-label="Export"
                        shape="circular"
                        appearance="subtle"
                        icon={<ExportBundle />}
                        onClick={openExportDialog}
                    >Export</Button>
                    </DialogTrigger>
                    <AssignmentDialog children={<ExportInfo/>}/>
                </Dialog>
                <Button
                    aria-label='Refresh'
                    shape='circular'
                    appearance='subtle'
                    icon={<RefreshBundle />}
                    onClick={handleRefresh}
                    disabled={isListOptionFetching || isUserAssignmentFetching}
                >Refresh</Button>
            </ToolbarGroup>
        </Toolbar>
    );
}